var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #313131;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-black",
    transform: "translate(-474 1011)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    className: "cls-1",
    width: 200,
    height: 200,
    transform: "translate(474 -1011)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-calendar",
    "data-name": "Icon feather-calendar",
    transform: "translate(487.217 -1005.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-2",
    d: "M22.267-2.5H151.3a26.3,26.3,0,0,1,26.267,26.267V152.8A26.3,26.3,0,0,1,151.3,179.067H22.267A26.3,26.3,0,0,1-4,152.8V23.767A26.3,26.3,0,0,1,22.267-2.5ZM151.3,163.4a10.611,10.611,0,0,0,10.6-10.6V23.767a10.611,10.611,0,0,0-10.6-10.6H22.267a10.611,10.611,0,0,0-10.6,10.6V152.8a10.611,10.611,0,0,0,10.6,10.6Z",
    transform: "translate(0 15.433)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-2",
    d: "M23.334,47.035A7.834,7.834,0,0,1,15.5,39.2V2.334a7.834,7.834,0,1,1,15.668,0V39.2A7.834,7.834,0,0,1,23.334,47.035Z",
    transform: "translate(100.316 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-2",
    d: "M11.334,47.035A7.834,7.834,0,0,1,3.5,39.2V2.334a7.834,7.834,0,1,1,15.668,0V39.2A7.834,7.834,0,0,1,11.334,47.035Z",
    transform: "translate(38.583 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-2",
    d: "M169.733,22.168H3.834a7.834,7.834,0,1,1,0-15.668h165.9a7.834,7.834,0,1,1,0,15.668Z",
    transform: "translate(0 61.733)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarBlack);
export default __webpack_public_path__ + "static/media/calendar-black.c7438b8b83da18c6c6ff9221fa451e33.svg";
export { ForwardRef as ReactComponent };